import React from 'react';

const Dietary = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12.0359"
      y1="2.2171"
      x2="12"
      y2="12"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="12"
      x2="18.9296"
      y2="18.9934"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="12"
      x2="5.0704"
      y2="18.9934"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polygon
      points="6.409 13.683 6.09 13.729 5.229 8.489 5.92 8.391 6.409 13.683"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polygon
      points="8.333 11.975 7.89 11.902 8.27 5.582 9.23 5.741 8.333 11.975"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4142,17.6c-.6768,2.8107-3.7513,1.0305-4.8517.8039.9066-4.4015,3.5278-.4205,4.85-1.2789A1.1867,1.1867,0,0,1,14.4142,17.6Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="18.2566"
      cy="14.0087"
      r="0.4167"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="14.9541"
      cy="10.0682"
      r="0.4167"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2123,6.4547q-.0915-.3231.2219-.2024.0915.3231-.2219.2024a.7762.7762,0,0,0,1.0607,0,.7542.7542,0,0,0,0-1.0606,1.3917,1.3917,0,0,0-1.9091.01,1.35,1.35,0,0,0,1.9188,1.8994,1.3851,1.3851,0,0,0-.01-1.9091.7559.7559,0,0,0-1.0607,0A.7665.7665,0,0,0,15.2123,6.4547Z"
      fill="currentColor"
    />
    <path
      d="M18.5623,10.5861q-.0915-.3231.2219-.2025.0915.3232-.2219.2025a.7763.7763,0,0,0,1.0607,0,.7543.7543,0,0,0,0-1.0607,1.3916,1.3916,0,0,0-1.9091.01,1.35,1.35,0,1,0,1.9188,1.8994,1.3853,1.3853,0,0,0-.01-1.9092.7559.7559,0,0,0-1.0607,0A.7667.7667,0,0,0,18.5623,10.5861Z"
      fill="currentColor"
    />
  </svg>
);

export default Dietary;
